import React from "react";
import Table from "react-bootstrap/Table";
import "./style.css";

interface ConfirmationOfChangesProps {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const ConfirmationOfChanges: React.FC<ConfirmationOfChangesProps> = ({
  formData,
  setFormData,
}) => {
  const tableHeaders = ["Audit Type", "Description of Changes", "Auditor Name"];

  return (
    <div className="p-4">
      <Table bordered hover className="audit-details-table">
        <thead>
          <tr>
            {tableHeaders.map((header, index) => (
              <th key={index} className="audit-details-table-header">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
              <tr>
                <td className="audit-details-table-tr">{formData.ConfirmationOfChanges.Audit_Type__c || "--"}</td>
                <td className="audit-details-table-tr">
                  {formData.ConfirmationOfChanges.Description_Of_Changes__c || "--"}
                </td>
                <td className="audit-details-table-tr">
                  {formData.ConfirmationOfChanges.Auditor_Name__c || "--"}
                </td>
              </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default ConfirmationOfChanges;
